import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Config from 'config';

import './NavBar.scss';

const logoPath = require('logo.svg');

const NavBar = ({ logoutHandler }) => (
  <section className="hero">
    <div className="hero-head">
      <nav className="nav">
        <div className="nav-left">
          <Link className="nav-item" to="/">
            <img src={logoPath} alt="Grab Logo" />
          </Link>
          <span className="app-version">
            Marionette {Config.APP_VERSION}
          </span>
        </div>

        <span className="nav-toggle">
          <span />
          <span />
          <span />
        </span>

        <div className="nav-right nav-menu">
          <Link className="nav-item" to="/app" title="Home" aria-label="Home">
            <span className="icon" aria-hidden="true">
              <i className="fa fa-home" />
            </span>
          </Link>
          <Link
            className="nav-item"
            to="/dashboard"
            title="Dashboards"
            aria-label="Dashboards"
          >
            <span className="icon" aria-hidden="true">
              <i className="fa fa-dashboard" />
            </span>
          </Link>
          <Link className="nav-item" to="/token" title="User Token" aria-label="User Token">
            <span className="icon" aria-hidden="true">
              <i className="fa fa-key" />
            </span>
          </Link>
          <Link className="nav-item" to="/library" title="Library" aria-label="Library">
            <span className="icon" aria-hidden="true">
              <i className="fa fa-users" />
            </span>
          </Link>
          <Link
            className="nav-item"
            to="/auto"
            title="Automatic Simulation"
            aria-label="Automatic Simulation"
          >
            <span className="icon" aria-hidden="true">
              <i className="fa fa-magic" />
            </span>
          </Link>
          <Link
            className="nav-item"
            to="/generate-resources"
            title="Generate Resources"
            aria-label="Generate Resources"
          >
            <span className="icon" aria-hidden="true">
              <i className="fa fa-plus-square" />
            </span>
          </Link>
          <a
            className="nav-item"
            target="_blank"
            href="https://wiki.grab.com/display/QUAL/Marionette"
            rel="noopener noreferrer"
            title="Marionette Wiki"
            aria-label="Marionette Wiki"
          >
            <span className="icon" aria-hidden="true">
              <i className="fa fa-question-circle" />
            </span>
          </a>
          <Link
            className="nav-item"
            to="/"
            title="Logout"
            aria-label="Logout"
            onClick={logoutHandler}
          >
            <span className="icon" aria-hidden="true">
              <i className="fa fa-sign-out" />
            </span>
          </Link>
        </div>
      </nav>
    </div>
  </section>
);

NavBar.propTypes = {
  logoutHandler: PropTypes.func,
  jwtHandler: PropTypes.func,
};

NavBar.defaultProps = {
  logoutHandler: () => {

  },
  jwtHandler: () => {

  },
};

export default NavBar;



/** WEBPACK FOOTER **
 ** ./src/js/components/layout/NavBar.jsx
 **/